export default {
  buttonNext: {
    backgroundColor: '#4461D4',
    height: 36,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    borderRadius: 999,
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#3951B8',
      transform: 'translateY(-1px)'
    }
  },
  buttonBack: {
    color: '#1660F3',
    backgroundColor: 'transparent',
    border: 'none',
    fontWeight: 500,
    fontSize: 14,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#3951B8',
      transform: 'translateY(-1px)'
    }
  }
}
